import { render } from "./ArticlesContent.vue?vue&type=template&id=575da960&ts=true"
import script from "./ArticlesContent.vue?vue&type=script&setup=true&lang=ts"
export * from "./ArticlesContent.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/js/components/ArticlesContent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "575da960"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('575da960', __exports__)) {
    api.reload('575da960', __exports__)
  }
  
  module.hot.accept("./ArticlesContent.vue?vue&type=template&id=575da960&ts=true", () => {
    api.rerender('575da960', render)
  })

}


export default __exports__